<template>
  <div class="h5 h5-esign-header-container">
    <div class="esign-header-wrapper">
      <h1 class="esign-logo">
        <a href="/"><img src="@/assets/images/blacklogo.png"/></a>
      </h1>
      <div class="operation" id="h5-header-operation">
        <i v-show="collapsed" class="icon-collapsed" data-type="collapsed" @click="collapsed = false"></i>
        <i v-show="!collapsed" class="icon-close" data-type="close" @click="collapsed = true">+</i>
      </div>
    </div>
    <div v-show="!collapsed" class="h5-menu-container" id="h5-menu-container">
      <div v-for="menu in navConfig" :key="menu.id" class="menu-sub-wrapper">
        <div class="title" @click="handleClickMenu(menu.id)">{{ menu.title }}</div>
        <div v-for="menuSub in menuSubList(menu.children)" v-show="menu.id === current" :key="menuSub.id" class="menu-sub">
          <div class="sub-title" @click="handleClickSubMenu(menuSub.id)">{{ menuSub.title }}</div>
          <ul v-show="menuSub.id === subCurrent" class="menu-item">
            <li v-for="item in menuSub.children" :key="item.id" class="menu-link">
              <a :href="item.link">
                {{ item.title }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-show="!collapsed" class="menu-container-bottom">
      <a href="/site/quotation" class="look-money-btn">查看价格</a>
      <EButton class="login-btn" type="primary" ghost @click="handleClickLogin">登录</EButton>
    </div>
  </div>
</template>
<script>
import EButton from '@/components/basics/MButton.vue'
export default {
  components: {
    EButton,
  },
  props: {
    navTree: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      current: '',
      subCurrent: '',
      collapsed: true,
      navConfig: this.navTree,
    }
  },
  methods: {
    handleClickLogin() {
      window.location.href = 'https://web.esign.cn/workspace/home'
    },
    menuSubList(menuSub = []) {
      return menuSub
        .filter(sub => {
          return sub.enable
        })
        .map(item => {
          return {
            ...item,
            children: item.children.filter(item => {
              return item.enable
            }),
          }
        })
    },
    handleClickMenu(id) {
      if (this.current === id) {
        // 收起
        this.current = ''

        return
      }
      // 展开
      this.current = id
    },
    handleClickSubMenu(id) {
      if (this.subCurrent === id) {
        // 收起
        this.subCurrent = ''

        return
      }
      // 展开
      this.subCurrent = id
    },
  },
}
</script>
<style lang="less" scoped>
a {
  font-size: 0.4267rem;
}
.h5-esign-header-container {
  position: fixed;
  width: 100%;
  z-index: 100001;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(0.8rem);

  .esign-header-wrapper {
    width: 100%;
    height: 1.3333rem;
    padding: 0.32rem 0.5867rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0rem 0.16rem 0.16rem 0rem rgba(230, 230, 230, 0.5);
  }
  .esign-logo {
    width: 2.8267rem;
    a {
      display: inline-block;
      width: 100%;
      height: 0.7467rem;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
  .operation {
    cursor: pointer;
  }
  .icon-collapsed {
    display: inline-block;
    width: 0.5333rem;
    height: 0.3733rem;
    background: url('../../assets/images/new-header/collapsed-icon.png');
    background-size: 100%;
  }
  .icon-close {
    display: inline-block;
    transform: rotate(45deg);
    font-size: 0.8rem;
  }
  .h5-menu-container {
    width: 100%;
    height: calc(100vh - 4.8rem);
    overflow: auto;

    line-height: 1.3333rem;
    font-size: 0.3733rem;
    .title {
      cursor: pointer;
      border-bottom: 0.0267rem solid #e6e6e6;
      padding: 0 0.5333rem;
      font-size: 0.3733rem;
    }
    .menu-sub {
      padding-left: 1.0667rem;
    }
    .sub-title {
      font-weight: 600;
      cursor: pointer;
      font-size: 0.3733rem;
    }
    .menu-link {
      font-size: 0.3733rem;
      a {
        color: #000;
        font-size: 0.3733rem;
      }
    }
  }
  .menu-container-bottom {
    padding: 0.5333rem 0.5333rem 1.0667rem;
    width: 100%;
    box-shadow: 0rem -0.16rem 0.16rem 0rem rgba(230, 230, 230, 0.5);
    .look-money-btn {
      display: inline-block;
      width: 100%;
      height: 0.8533rem;
      border: 1px solid #cc0000;
      color: #cc0000;
      text-align: center;
      line-height: 0.8533rem;
      font-size: 0.3733rem;
    }
    .login-btn {
      width: 100%;
      color: #fff;
      background: #cc0000;
      margin-top: 0.4rem;
    }
  }
}
</style>
